export const VISION_API_BASE_URL = process.env.NEXT_PUBLIC_VISION_API_BASE_URL;
export const VISION_API_AU_BASE_URL = process.env.NEXT_PUBLIC_VISION_AU_API_BASE_URL;
export const S3_CDN = process.env.NEXT_PUBLIC_S3_ENDPOINT;
export const REALTIME_SERVICE_URL = process.env.NEXT_PUBLIC_REALTIME_SERVICE_URL;
export const VERSION = "v1";
